export default __webpack_public_path__ + "static/media/Card-LatitudeGemVisa.d1381c40.png";